import React, { useContext, useEffect, useState } from 'react'
import { getFeeAmount } from '../../../utils/fee'
import { X, Check } from 'react-feather'
import { Input } from 'reactstrap'
import Loader from '../../../Common/Component/Loader'
import { FEE_AMOUNT_CHANGE } from '../../../Constant'
import courseContext from '../../../Helper/Courses'
import { addAdminActivity, changeStudentCourse } from '../../../firebase/utils'
import StudentContext from '../../../Helper/Students'
import { toast } from 'react-toastify'
import AdminContext from '../../../Helper/admin'
import useFetchUserRoles from '../../../hook'
import { isAccess } from '../../../utils/adminRoles'


const FeeAmountColumn = ({ data, module, amount, setAmount, setTotal, updateStudents, courseStudents }) => {
  const { students, setStudents } = useContext(StudentContext)
  const { activeCourse } = useContext(courseContext)
  const { user, location } = useContext(AdminContext)
  const hasAccessToEditFee = useFetchUserRoles('amountUpdate', isAccess)


  const [loading, setLoading] = useState(false)
  const [feeEdit, setFeeEdit] = useState(false)

  const fee = data.courses[data.courseIndex].feeScreenshots[module]
  const totalFee = fee?.feeAmount || 0
  const [totalAmount, setTotalAmount] = useState(totalFee || 0)
  const imageText = fee?.imageText || ""
  const extractedText = imageText?.replace(/[\(\)']+/g, "").match(/Rs.\s?([\d,]+\.\d+)/i);

  const handleFeeAmount = async () => {
    if (hasAccessToEditFee) {
      if (loading) return;
      const activityOptions = {
        adminId: user.email,
        activityOnUser: data.email,
        type: FEE_AMOUNT_CHANGE,
        createdAt: new Date(),
        activity: `${user.email} change fee amount from ${totalFee} to ${totalAmount} of ${activeCourse.name} course module ${module === 0 ? 1 : 2}`,
      };
      if (totalAmount) {
        setLoading(true);
        try {
          data.courses[data.courseIndex].feeScreenshots[module]['feeAmount'] =
            +totalAmount;
          await addAdminActivity(activityOptions, location);
          await changeStudentCourse(data.email, data.courses)
          toast.success("Course fee amount updated successfully!");
          setTotal();
          updateFeeData()
          closeFeeEdit()
          setLoading(false);
        } catch (error) {
          console.log("error", error);
        } finally {
          setLoading(false)
        }
      } else {
        closeFeeEdit()
      }
    } else {
      toast.error(
        "You don't have access, please ask Super Admin to provide you access!"
      );
    }
  }


  const updateFeeData = () => {
    const studentMainDataIndex = students.findIndex((student) => student.email === data.email)
    const studentsLocalDataIndex = courseStudents.findIndex((student) => student.email === data.email)
    setStudents(previousStudents => {
      const newStudent = [...previousStudents];
      students[studentMainDataIndex] = data;
      return newStudent;
    });
    updateStudents(previousStudents => {
      const newStudent = [...previousStudents];
      courseStudents[studentsLocalDataIndex] = data;
      return newStudent;
    });
  }

  const closeFeeEdit = () => {
    if (feeEdit) setFeeEdit(false)
  }

  useEffect(() => {
    let feeAmount =
      extractedText && extractedText[1].replace(/,/g, "").split(".")[0];
    if (amount && extractedText && feeAmount !== +totalFee) {
      setTotalAmount(feeAmount);
      setFeeEdit(true)
    }
  }, [amount]);

  return (
    <>
      {loading ? <Loader /> : (feeEdit || amount) && fee ?
        <div className='fee-amount-conatiner'>
          <Input type='number' value={totalAmount} onChange={(e) => setTotalAmount(e.target.value)} />
          <div>
            <Check className='check-icon' onClick={handleFeeAmount} />
            <X className='cross-icon' onClick={() => closeFeeEdit()} />
          </div>
        </div> :
        <div onClick={() => setFeeEdit(true)}>{getFeeAmount(data.courses[data.courseIndex].feeScreenshots, module)}</div>
      }
    </>
  )
}

export default FeeAmountColumn